<template>
  <div class="step-container" :style="{ '--lineWidth': `${lineWidth}px`, '--right': `-${lineWidth}px` }">
    <div 
      :class="['step-item',{ 'step-item-next': index !== value.length - 1 },{ 'step-item-active': index <= current },{ 'step-litem-active': index < current }]"
      v-for="(item, index) in value"
      :key="index">
      <span class="step-item-no">{{ `0${index + 1}` }}</span>{{ item }}
    </div>
  </div>
  <!-- <div
    class="step-container"
    :style="{ '--lineWidth': `${lineWidth}px`, '--right': `-${lineWidth}px` }"
  >
    <div
      :class="[
        'step-item',
        { 'step-item-next': index !== value.length - 1 },
        { 'step-item-active': index <= current },
      ]"
      :style="{
        marginRight: index !== value.length - 1 ? `${lineWidth}px` : '',
      }"
      :data-lineWidth="`${lineWidth}px`"
      v-for="(item, index) in value"
      :key="index"
    >
      <span class="step-item-no">{{ index + 1 }}</span
      >{{ item }}
    </div>
  </div> -->
</template>

<script>
export default {
  name: "navStepList",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    current: {
      type: Number,
      default: 0,
    },
    lineWidth: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="less" scoped>
  .step-container{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .step-item{
      position: relative;
      width: 200px;
      line-height: 50px;
      height: 50px;
      background-color: #4E312D;
      border-top-right-radius: 50px;
      border-bottom-right-radius: 50px;
      color: #fff;
      text-align: center;
      padding-right: 20px;
      z-index: 1;
      &:last-child{
        &::before{
          background-color: transparent;
        }
      }
      &::before{
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        display: inline-block;
        width: 25px;
        height: 50px;
        background-color: #4E312D;
      }
      .step-item-no {
        font-size: 18px;
        margin-right: 10px;
        color: #fff;
      }
      
    }
    .step-item-active {
      background-color: #F85A36;
      transition: all 0.3s;
      &::after{
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        display: inline-block;
        width: 25px;
        height: 50px;
        background-color: #F85A36;
        border-top-right-radius: 50px;
        border-bottom-right-radius: 50px;
        z-index: 1;
      }
    }
    .step-litem-active{
      &::before{
        background-color: #F85A36;
      }
    }
  }
// .step-container {
//   display: flex;
//   align-items: center;
//   .step-item {
//     min-width: 200px;
//     display: flex;
//     align-items: center;
//     background-color: #999999;
//     border-radius: 40px;
//     padding: 10px 20px;
//     font-size: 16px;
//     font-weight: bold;
//     color: #fff;
//     position: relative;
//     .step-item-no {
//       color: #999999;
//       font-size: 800;
//       background-color: #fff;
//       text-align: center;
//       width: var(--lineWidth);
//       height: 40px;
//       line-height: 40px;
//       border-radius: 50%;
//       margin-right: 19px;
//     }
//   }
//   .step-item-next {
//     &::after {
//       content: "";
//       position: absolute;
//       top: 50%;
//       right: var(--right);
//       transform: translateY(-50%);
//       display: inline-block;
//       width: var(--lineWidth);
//       height: 2px;
//       background-color: #e8e8e8;
//     }
//   }
//   .step-item-active {
//     background-color: #3992e9;
//     transition: all 0.3s;
//     .step-item-no {
//       color: #3992e9;
//     }
//   }
// }
</style>
